import { freightDeliveryAccessorialPresetIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const deleteFreightDeliveryAccessorialPreset = {
  name: "deleteFreightDeliveryAccessorialPreset" as const,
  input: z.object({ id: freightDeliveryAccessorialPresetIdFormat.schema }),
  output: z.object({}),
};
